export class StatusPageState {}
